import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerInsumo = styled(motion.div)`
    width: 33%;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 15px;
    position: relative;

    p.ContainerInsumo__title {
        font-weight: 600;
        color: var(--text-color);
        width: 100%;
        font-size: 14px;
        margin: 0;
        padding: 0;
    }

    button.ContainerInsumo__unidade {
        position: absolute;
        top: 16px;
        right: 10px;
        font-weight: 500;
        font-size: 12px;
        display: flex;
        align-items: center;
        gap: 5px;
        border: none;
        background: transparent;
        cursor: pointer;

        :hover {
            background: var(--hover-color);
        }
    }

    div.ContainerInsumo__opt_unidade {
        width: 200px;
        box-sizing: border-box;
        padding: 10px;
        background: #fff;
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
        z-index: 100;

        button.ContainerInsumo__opt_unidade__item {
            width: 100%;
            height: 40px;
            border-radius: 5px;
            border: none;
            background: #fff;
            color: var(--text-color);
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            text-align: left;

            :hover {
                background: #d5ffe8;
            }
        }
    }

    div.ContainerInsumo__list {
        width: 100%;
        margin-top: 10px;
        height: calc(100% - 30px);
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        padding-right: 10px;

        button.ContainerInsumo__list__item {
            /* width: 100%; */
            height: 30px;
            min-height: 30px;
            background: #5DA57D;
            border-radius: 4px;
            border: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 5px 0px;
            cursor: pointer;

            :hover {
                filter: brightness(95%);
            }

            span.ContainerInsumo__list__item__name {
                font-weight: 700;
                font-size: 13px;
                color: #fff;
                text-align: left;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                text-transform: capitalize;
            }
            
            span.ContainerInsumo__list__item__size_incoculante {
                height: 20px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
                font-weight: 600;
                font-size: 11px;
                padding: 5px;
                color: #fff;
                white-space: nowrap;
                font-feature-settings: "tnum";
                border: 1px dashed #fff;
            }
            span.ContainerInsumo__list__item__size {
                background: #fff;
                height: 20px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
                font-weight: 700;
                font-size: 13px;
                padding: 5px;
                color: var(--primary-color);
                white-space: nowrap;
                font-feature-settings: "tnum"
            }
        }
    }
`;